export const env = {
  pocketbaseUrl: import.meta.env.VITE_POCKETBASE_URL ,
  appName: import.meta.env.VITE_APP_NAME || 'HRM SaaS',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  env: import.meta.env.VITE_ENV || 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

